import React, { useState } from "react";

const items = ["PM2.5", "PM10", "NOx", "CO", "NH3", "CH4", "N2O", "NMVOC"];

export default function Results(props) {
  const [Seleted, setSeleted] = useState("");

  return (
    <div className="flex justify-center items-center flex-col">
      <h1 className="pb-3 text-2xl font-bold">Choose result card !!</h1>
      <div className="grid grid-cols-4 gap-8">
        {items.map((item, index) => (
          <div
            key={index}
            className={`w-24 h-16 rounded-2xl shadow-lg flex items-center justify-center cursor-pointer transform transition-transform hover:scale-125 hover:rotate-6 text-white font-bold ${
              Seleted === item ? `bg-gain scale-125 rotate-0` : `bg-primary`
            }`}
            onClick={() => {
              setSeleted(item);
              props.onSelect(`Result_${item}`);
            }}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}
